import localStorageUtil from '@/common/utils/localStorageUtil';
import Constant from '@/common/constant/Constant';
import {
    createNewTicketAPI, saveDraftTicketAPI,
} from '@/service/ticketService';
import { copyFileOfTicketDraftTo, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import { I18n } from 'aws-amplify';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import Utils from '@/common/utils/utils';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';

export const onCreateInvitationGuestProjectTicketHandler = async (
    argsAll,
    formData,
    userDetail,
    panelId,
    panelType,
    tabId,
    corporationDetail,
    formId,
    fields,
    forceCreate
) => {
    argsAll.setIsLoading(true);

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };
    // if (argsAll?.fileUploadList?.length) {
    //     uploadFileS3Result = await handleUploadFilesForTicket(
    //             formData,
    //             argsAll.setFileUploading,
    //             argsAll.fileUploadList
    //         );
    // }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };
    

    const requestBody = {
        createTicketRequestDto: {
            corporationOrigin: corporationDetail.id,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            type: formId,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.PUBLIC,
            fields,
            forceCreate: forceCreate ? forceCreate : false,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            subDomainInvited: formData?.subDomainInvited,
            ...draftTicketInfo
        },
    };
   
    const newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        }
        if (
            newTicket.errorMessage === 'COMM01MSG04'
        ) {
            argsAll.setErrorCreateTicket(
                'subDomainInvited',
                { type: 'manual', message: I18n.get('COMM01MSG04') },
                { shouldFocus: false }
            );
        } else {
            argsAll.setErrorCreateTicketMsgCode(newTicket.err);
        } 
        
        argsAll.setIsLoading(false);
        return;
    }
    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: formId,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);
    argsAll.setIsLoading(false);
    
    if (!tabId) {
        tabId = argsAll.ticketId;
    }
    
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);
    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket.id,
        ticketOutline: newTicket.outline,
        API: argsAll.API
    });
   
    argsAll.enqueueSnackbar(I18n.get('MSG-B2B-SET-NEW-COUNTER-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return newTicket;
}
    

export const onSaveDraftInvitationGuestProjectTicketHandler = async (
    argsAll,
    formData,
    userDetail,
    corporationDetail,
    formId,
    fields
) => {
    argsAll.setIsLoading(true);

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    if (formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]?.length) {
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    const requestBody = {
        createTicketRequestDto: {
            corporationOrigin: corporationDetail.id,
            createUserId: userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_PROJECT,
            type: formId,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            subDomainInvited: formData?.subDomainInvited,
            outline: I18n.get('USER04BTN038'),
            ...draftTicketInfo,
        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED,
        formId: formId,
        projectTargetId: formData?.projectTarget,
        corpTargetId: formData?.corporationTarget ? formData?.corporationTarget : argsAll?.corporationDetail?.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    newTicket.outline = I18n.get('USER04BTN038')

    return newTicket;
};